import {getComponent} from "../jsbase/utils";

export default {
    args: 'targetEl',
    targetEl: null,

    props: {
        targetEl: String,
        filteredList: String,
    },

    connect() {
        this.targetEl = document.getElementById(this.el.getAttribute('data-load-part-btn'));
    },

    methods: {
        getFilteredList() {
            if (this.filteredList && !this.filteredListEl) {
                // let targetEl = document.getElementById(this.filteredList);
                this.filteredListEl = getComponent(this.filteredList, 'filtered-list');
            }
            return this.filteredListEl;
        },
    },

    events: [{
        name: 'click',
        handler(ev) {
            if (this.getFilteredList()) {
                this.getFilteredList().load();
            } else {
                connection.loadPartWith($(this.targetEl), { dataType: 'json' });
            }
        }
    }],

}
